export default __webpack_public_path__ + "static/media/264.51737a79.jpg";